import { useQuery } from "@tanstack/react-query";

import { list } from "../services/workspaceRoles";

const queryKey = "workspaceRoles";

export const useWorkspaceRoles = () => {
  return useQuery({
    queryFn: async () => {
      const response = await list();
      return response;
    },
    queryKey: [queryKey],
    refetchOnWindowFocus: false,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};
